<template>
  <div>
    <form-dialog :title="title" :dialogVisible="mtCheckVisible" dWidth="900px" :dtop="dtop" :isAppend="isAppend" @closeDialog="mtCheckClose">
      <div class="diamain">
        <div class="header">
          <div class="button-groups">
            <div class="button" @click="changeType('play')" :class="{isButtonActive:this.current_type=='play'}">
              {{$t('terminal.programList')}}</div>
            <div class="button" @click="changeType('terminal')" :class="{isButtonActive:this.current_type=='terminal'}">{{$t('schedule.terminalList')}}</div>
            <!-- <div class="button" @click="changeType('publish')" :class="{isButtonActive:this.current_type=='publish'}">{{$t('schedule.releaseProp')}}</div> -->
            <div class="button" @click="changeType('timerShaft')" :class="{isButtonActive:this.current_type=='timerShaft'}">播放时间轴</div>
          </div>
        </div>
        <div class="diaimg">
          <template v-if="current_type=='play'">
            <el-table :data="play_table_list" :key="Math.random()" height="100%">
              <el-table-column :label="$t('review.screenshot')">
                <template slot-scope="scope">
                  <template v-if="scope.row.damaged==0">
                    <img :src="scope.row.pimg" style="width: 96px;height: 54px;" />
                  </template>
                  <template v-else>
                    <img src="@/assets/images/public/damaged.png" style="width: 96px;height: 54px;" />
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="name" :label="$t('terminal.proName')" width="150px">
                <template slot-scope="scope">
                  <template v-if="scope.row.damaged==0">
                    <el-link :underline="false" type="primary" @click="lookProgram(scope.row,scope.$index)">{{scope.row.name}}</el-link>
                  </template>
                  <template v-else>
                    <span style="color: red;">{{scope.row.name}}</span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="group_name" :label="$t('schedule.structure')">
              </el-table-column>
              <el-table-column prop="size_remark" :label="$t('schedule.planSize')">
              </el-table-column>
              <el-table-column prop="create_time" :label="$t('terminal.createTime')">
              </el-table-column>
            </el-table>
          </template>
          <template v-if="current_type=='terminal'">
            <el-table :data="device_table_list" height="280" v-loading="deviceListLoading" :key="Math.random()">
              <el-table-column prop="name" :label="$t('terminal.deviceName')">
              </el-table-column>
              <el-table-column prop="remark1" :label="$t('terminal.remark')">
                <template slot-scope="scope">
                  <template v-if="scope.row.remark1==''">
                    -
                  </template>
                  <template v-else>
                    scope.row.remark1
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="group_name" :label="$t('review.group')">
              </el-table-column>
              <el-table-column prop="size_remark" :label="$t('schedule.resolution')"></el-table-column>
              <el-table-column :label="$t('terminal.status')">
                <template slot-scope="scope">
                  <span :style="'color:' + scope.row.runStateInfo.stateColor">{{ $t(scope.row.runStateInfo.stateName) }}</span>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template v-if="current_type=='publish'">
            <el-table :data="publishInfo" :key="Math.random()" height="280">
              <el-table-column prop="publish_no" :label="$t('schedule.planName')">
              </el-table-column>
              <el-table-column prop="publish_type" :label="$t('schedule.releaseType')">
                <template slot-scope="scope">
                  <template v-if="scope.row.play_mode==1">
                    {{$t('review.loop')}}
                  </template>
                  <template v-if="scope.row.play_mode==2">
                    {{$t('review.timming')}}
                  </template>
                  <template v-if="scope.row.play_mode==3">
                    {{$t('review.instream')}}
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="remark1" :label="$t('schedule.releaseProp')">
                <template slot-scope="scope">
                  <template v-if="scope.row.adapter_screen==0">
                    {{$t('review.noAdap')}}
                  </template>
                  <template v-if="scope.row.adapter_screen==1">
                    {{$t('review.adap')}}
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="publish_state" :label="$t('schedule.publishSate')">
                <template slot-scope="scope">
                  <template v-if="scope.row.publish_state==0">
                    <span>{{$t('schedule.waitRelease')}}</span>
                  </template>
                  <template v-if="scope.row.publish_state==1">
                    <span style="color: red;">{{$t('review.reject')}}</span>
                  </template>
                  <template v-if="scope.row.publish_state==2">
                    <span style="color: #00c48f;">{{$t('review.pass')}}</span>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template v-if="current_type=='timerShaft'">
            <timer-shaft :timeInfo="schedule"></timer-shaft>
          </template>
        </div>
        <div class="diainput">
          <template v-if="this.current_detail!=null">
            <template v-if="this.current_detail.publish_state==0">
              <div class="content">
                <el-input v-model="reject_data" size="small" :placeholder="$t('review.resonForReject')"></el-input>
              </div>
              <div class="button">
                <el-button type="success" size="small" style="margin-left: 6px;" @click="publish()" round>{{$t('review.approve')}}</el-button>
                <el-button type="danger" size="small" @click="reject()" round>{{$t('review.rejectReview')}}</el-button>
                <!-- <div class="publishs" @click="publish()">通过</div>
							<div class="reject" @click="reject()">拒绝</div> -->
              </div>
            </template>
            <template v-if="this.current_detail.publish_state==2">
              <div style="width: 100%;text-align: center;color: green;font-size: 20px;">{{$t('review.pass')}}</div>
            </template>
            <template v-if="this.current_detail.publish_state==1">
              <div style="width: 100%;text-align: center;font-size: 20px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                <span style="color: red">{{$t('review.reject')}}</span>
                <span>:</span>
                <el-popover placement="top-start" trigger="hover" width="200" :content="this.current_detail.check_remark">
                  <span slot="reference" style="margin-left: 10px;">
                    {{this.current_detail.check_remark}}</span>
                </el-popover>
              </div>
            </template>
          </template>
        </div>
      </div>
    </form-dialog>
    <el-dialog custom-class="look-p" width="800px" title="节目预览" top="20vh" @close="closeLookp" :visible.sync="lookp" append-to-body center>
      <div style="margin-bottom: 16px;">{{ screenParam.name }}</div>
      <div v-if="initLook" style="height: 320px; border-top: 1px solid #d7ecf3;">
        <program-preview :screenParam="screenParam" :vdrList="vdrList"></program-preview>
      </div>
      <div class="flex-a-c" style="margin-top: 16px;">
        <el-button size="mini" :disabled="lookpIndex === 0" @click="nextLookP(-1)">上一个</el-button>
        <el-button size="mini" :disabled="lookpIndex === (play_table_list.length - 1)" @click="nextLookP(1)">下一个</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const publishURL = "/admin/check/checkPublish";
import ProgramPreview from './ProgramPreview'
import FormDialog from '@/components/basics/FormDialogConfirm';
import {
  mPagination
} from "@/components/basics/mixins";
import {
  runStateInfo
} from "@/assets/scripts/runState";
import {
  changeDeviceStateName
} from "@/assets/scripts/changeDeviceStateName";
import TimerShaft from "@/components/schedule/children/items/TimerShaft.vue"

export default {
  name: "PublishCheck",
  mixins: [mPagination],
  components: {
    FormDialog,
    ProgramPreview,
    TimerShaft
  },
  props: {
    current_detail: {
      type: Object,
      default: null
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    play_table_list: {
      type: Array
    },
    deviceList: {
      type: Array
    },
    publishInfo: {
      type: Array
    },
    scheduleList: {
      type: Array
    },
    playList: {
      type: Array
    },
    isAppend: {
      type: Boolean,
      default: false
    },
    dtop: {
      type: String,
      default: '0'
    },
    title: {
      type: String,
      default: "发布审核"
    }
  },
  data() {
    return {
      mtCheckVisible: false,
      deviceListLoading: false,
      current_type: 'play',
      device_table_list: [],
      schedule: [],
      reject_data: '',
      lookp: false,
      initLook: true,
      lookpIndex: 0,
      vdrList: [],
      screenParam: {
        type: 'look', //add/look/edit/copy
        name: '',
        groupId: '',
        resolution: '',
        id: '',
        w: '',
        h: ''
      }
    }
  },
  methods: {
    async lookProgram(row, index) {
      this.lookpIndex = index;
      let wh = row.size_remark.split("x");
      this.screenParam.name = row.name;
      this.screenParam.groupId = row.group_id;
      this.screenParam.resolution = row.size_remark;
      this.screenParam.id = row.id;
      this.screenParam.w = wh[0];
      this.screenParam.h = wh[1];
      await this.$http.post("/admin/play/detail", { play_id: this.screenParam.id }, data => {
        this.vdrList = data.object_json;
      });
      this.lookp = true;

      this.initLook = false;
      setTimeout(() => { this.initLook = true; }, 10);
    },
    closeLookp() {
      this.lookp = false;
    },
    nextLookP(val) {
      let index = this.lookpIndex + val;
      let length = this.play_table_list.length;
      console.log(val, index, length);
      if (index > -1 && index < length) {
        this.lookProgram(this.play_table_list[index], index);
      }
    },
    mtCheckClose() {
      this.mtCheckVisible = false;
      this.$emit('closeCheck');
    },
    changeType(type) {
      this.current_type = type;
      if (this.current_type == 'terminal') {
        let device_ids = [];
        this.deviceList.forEach((ele) => {
          device_ids.push(ele.id)
        });
        this.deviceListLoading = true;
        this.$http.post('/admin/device/list', {
          group_ids: sessionStorage.getItem('group_ids'),
          limit: 1000,
          page: 1,
          device_ids: device_ids.toString()
        }, data => {
          this.device_table_list = data.list ? data.list : [];
          this.device_table_list.forEach((ele) => {
            ele.runStateInfo = runStateInfo(ele.run_state, ele.group_run_status);
            ele.runStateInfo = changeDeviceStateName(ele.runStateInfo);
          })
          this.deviceListLoading = false;
        });
      }

      if (type === 'timerShaft') {
        let sObj = {};

        this.scheduleList.forEach((s) => {
          const { name } = s;
          sObj[name] = sObj[name] ? sObj[name] : [];
          sObj[name].push(s);
        });

        let list = []
        for (const s in sObj) {
          let schedule = sObj[s].map((item) => {
            console.log(item);
            const { dateEnd, dateStart, endTime, startTime, validWeek: weekValue, isDateLimit } = item;

            // return { dateEnd: new Date(dateEnd), dateStart: new Date(dateStart), endTime, startTime, validWeek };
            return isDateLimit ? { dateEnd: new Date(dateEnd), dateStart: new Date(dateStart), endTime, startTime, weekValue } : { endTime, startTime, weekValue }
          });
          list.push({ name: s, schedule });
        }
        this.schedule = list;
      }
    },
    async publish() {
      await this.$http.post(publishURL, {
        check_result: 2,
        remark: this.reject_data,
        publish_ids: this.current_detail.id
      });
      this.$http.post("/admin/Command/getDownloadList", {}, data => {
        this.$store.commit("ISSUE_LIST", data);
      });
      this.$emit('updateData');
      this.mtCheckVisible = false;
    },
    async reject() {
      if (!this.reject_data) {
        this.$msg({
          type: 'warning',
          message: this.$t('review.resonForReject')
        })
      } else {
        await this.$http.post(publishURL, {
          check_result: 1,
          remark: this.reject_data,
          publish_ids: this.current_detail.id
        })
        this.$emit('updateData');
        console.log('原因', this.reject_data);
        this.mtCheckVisible = false;
      }
    },
  },
  watch: {
    isVisible() {
      this.current_type = 'play';
      this.mtCheckVisible = this.isVisible;
    }
  }
}
</script>

<style lang="scss" scoped>
.diamain {
  width: 96%;
  height: 500px;
  margin: 5px auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  .header {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #d7ecf3;

    .button-groups {
      width: 420px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .button {
        text-align: center;
        width: 130px;
        height: 30px;
        line-height: 30px;
        border-style: solid;
        border-width: 1px;
        cursor: pointer;
        border-image-slice: 1;
        border-radius: 17px;
        color: #2fb3ff;
      }

      .isButtonActive {
        background-image: linear-gradient(
            270deg,
            #86eae7 0%,
            #4cccf0 45%,
            #11adf8 100%
          ),
          linear-gradient(#cfd5d8, #cfd5d8);
        background-blend-mode: normal, normal;
        color: #ffffff;
      }
    }

    .button-groups > .button:hover {
      background-color: rgba(216, 255, 253, 0.7);
    }
  }

  .diaimg {
    width: 830px;
    height: 400px;
    overflow-y: auto;

    .tab {
      width: 100%;
      height: calc(100% - 40px);
      overflow-y: scroll;

      background-color: pink;
    }

    /deep/ .el-tabs__content {
      flex-grow: 1;
      overflow-y: auto;
    }
  }

  .diainput {
    height: 60px;
    width: 100%;

    display: flex;
    align-items: center;

    .content {
      flex: 1;
    }

    // .button {
    // 	width: 30%;
    // 	padding-left: 20px;
    // 	display: flex;
    // 	align-items: center;
    // 	justify-content: space-between;
    // 	.publishs {
    // 		width: 80px;
    // 		height: 35px;
    // 		cursor: pointer;
    // 		border-style: solid;
    // 		border-width: 1px;
    // 		border-image-slice: 1;
    // 		border-color: linear-gradient(270deg,
    // 				#86eae7 0%,
    // 				#4cccf0 45%,
    // 				#11adf8 100%);
    // 		border-radius: 20px;
    // 		color: #2fb3ff;
    // 		line-height: 35px;
    // 		text-align: center;
    // 	}

    // 	.reject {
    // 		width: 80px;
    // 		height: 35px;
    // 		cursor: pointer;
    // 		border-style: solid;
    // 		border-width: 1px;
    // 		border-image-slice: 1;
    // 		border-color: linear-gradient(270deg,
    // 				#ff907e 0%,
    // 				#ff7878 45%,
    // 				#ff5f72 100%);
    // 		border-radius: 20px;
    // 		color: #ff4949;
    // 		line-height: 35px;
    // 		text-align: center;
    // 	}
    // }
  }
}
/deep/ .look-p {
  .el-dialog__body {
    padding-top: 0px !important;
    padding-bottom: 16px !important;
  }
}

@media screen and (min-width: 1200px) {
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: rgba(240, 240, 240, 1);
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    box-shadow: inset 0 0 0px rgba(53, 202, 250, 0.3);
    background-color: rgba(53, 202, 250, 0.3);
  }
}
</style>
